/*
 * Copyright (c) 2020.
 * Project: Source
 * LastModified: 2/14/20, 3:23 PM
 * Author: diengv < Giáp Văn Điện >
 * Email: diengv@ominext.com
 * File name: index.js
 * File path: D:/Projects/PMS/Source/Client/vuejs/src/stores/index.js
 */

import Vue from 'vue'
import Vuex from 'vuex'
import Modules from './modules'
import MutationType from './mutations-type'

Vue.use(Vuex)

export default new Vuex.Store({
    modules: {...Modules},
    strict: process.env.NODE_ENV !== 'production',
    state: {
        isOnline: true,
        prevRoute: '/user'
    },
    mutations: {
        [MutationType.updateOnlineFlag](state, flag) {
            state.isOnline = flag
        },
        [MutationType.updatePrevRouter](state, router) {
            state.prevRoute = router
        }
    },
    actions: {
        updateOnlineFlag({commit}, flag) {
            commit(MutationType.updateOnlineFlag, flag)
        },
        updatePrevRouter({commit}, router){
            commit(MutationType.updatePrevRouter, router)
        }
    }
})
